import { IconButton } from '@eventbrite/eds-icon-button';
import { HeartChunky, HeartFillChunky } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import './Bookmark.scss';

export type BookmarkProps = {
    isBookmarkedEvent: boolean;
    onClick: () => void;
};

const STYLE_BRAND = 'brand';
const STYLE_NEUTRAL = 'neutral';

export const Bookmark = (props: BookmarkProps) => {
    const { isBookmarkedEvent, onClick } = props;

    const className = isBookmarkedEvent ? 'bookmark is-active' : 'bookmark';

    return (
        <div className={className}>
            <IconButton
                aria-pressed={isBookmarkedEvent ? true : false}
                iconType={
                    isBookmarkedEvent ? <HeartFillChunky /> : <HeartChunky />
                }
                style={isBookmarkedEvent ? STYLE_BRAND : STYLE_NEUTRAL}
                onClick={onClick}
                title={gettext('Like Event')}
            />
        </div>
    );
};

export default Bookmark;
